import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';

import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NoopAnimationsModule, BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppMaterial } from './app.material';
import { TreeviewComponent } from './components/treeview/treeview.component';
import { HighlightPipe } from './utilities/highlight/highlight.pipe';
import { TranslatePipe } from './utilities/translate/translate.pipe';
import { TranslateService } from './utilities/translate/translate.service';
import { ModalComponent } from './services/modal/modal.component';
import { ElementOptionsComponent } from './resources/element/element-options/element-options.component';
import { UserIconComponent } from './components/user-icon/user-icon.component';
import { ConvertResourceToJsonPipe } from './utilities/convert-resource-to-json/convert-resource-to-json.pipe';
import { ModalPromptComponent } from './services/modal/modals/prompt/prompt.component';
import { ModalTinyMCEComponent } from './services/modal/modals/tinymce/tinymce.component';

import { EditorModule } from '@tinymce/tinymce-angular';

import { ElementLogsItemComponent } from './resources/element/element-sidebar/log-item/item.component';
import { ElementLogsCommentBoxComponent } from './resources/element/element-sidebar/comment-box/comment-box.component';
import { DateAgoPipe } from './utilities/date-ago/date-ago.pipe';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { InlineEditAreaFunctionalityComponent } from './components/inline-edit/area-functionality/area-functionality.component';
import { BuildingInfoRatioComponent } from './views/areas/building/building-info-ratio/building-info-ratio.component';
import { DecimalPipe, DatePipe } from '@angular/common';
import { ClusterInfoRatioComponent } from './views/areas/building/cluster-info-ratio/cluster-info-ratio.component';
import { BuildingOptionsComponent } from './resources/building/building-options/building-options.component';
import { ProjectInfoViewComponent } from './views/info/project-info-view/project-info-view.component';
import { ProjectInfoElementComponent } from './views/info/project-info-element/project-info-element.component';
import { PveFilterPipe } from './utilities/pve/pve-filter.pipe';
import { ProjectInfoToolbarComponent } from './views/info/project-info-toolbar/project-info-toolbar.component';
import { SafeHtmlPipe } from './utilities/safe-html/safe-html.pipe';
import { SubmoduleOptionsComponent } from './resources/submodule/submodule-options/submodule-options.component';
import { ProjectInfoIndexComponent } from './views/info/project-info-index/project-info-index.component';
import { ModuleOptionsComponent } from './resources/module/module-options/module-options.component';
import { ProjectInfoButtonAddComponent } from './views/info/project-info-button-add/project-info-button-add.component';
import { ModalAssignToComponent } from './services/modal/modals/assign-to/assign-to.component';
import { ElementViewComponent } from './views/elements/element-view/element-view.component';
import { ElementFormComponent } from './resources/element/element-form/element-form.component';
import { ElementStatusComponent } from './views/elements/element-status/element-status.component';
import { ElementAssignToComponent } from './views/elements/element-assign-to/element-assign-to.component';
import { ElementSidebarComponent } from './resources/element/element-sidebar/element-sidebar.component';
// import { DeviceDetectorModule } from 'ngx-device-detector';
import { ElementValueComponent } from './resources/element/element-value/element-value.component';
import { StripHtmlPipe } from './utilities/strip-html/strip-html.pipe';
import { ElementFormControlsComponent } from './resources/element/element-form/element-form-controls/element-form-controls.component';
import { AdminToolsViewComponent } from './views/admin/admin-tools-view/admin-tools-view.component';
import { AdminToolsFindCircularComponent } from './views/admin/admin-tools-find-circular/admin-tools-find-circular.component';
import { AreaDetailsViewComponent } from './views/areas/area/area-details-view/area-details-view.component';
import { UnitPipe } from './utilities/unit/unit.pipe';
import { StatusPipe } from './utilities/status/status.pipe';
import {
  ElementFormBreadcrumbsComponent
} from './resources/element/element-form/element-form-breadcrumbs/element-form-breadcrumbs.component';
import { AreaDetailsPropertiesComponent } from './views/areas/area/area-details-properties/area-details-properties.component';
import {
  BasicAreaDetailsPropertiesComponent
} from './views/areas/area/basic-area-details-properties/basic-area-details-properties.component';
import { ElementsViewComponent } from './views/elements/elements-view/elements-view.component';
import { ElementsTableComponent } from './views/elements/elements-table/elements-table.component';
import { ModalFiltersComponent } from './services/modal/modals/filters/filters.component';
import { ModalParagraphAddComponent } from './services/modal/modals/paragraph-add/paragraph-add.component';
import { ModalRestoreParagraphComponent } from './services/modal/modals/restore-paragraph/restore-paragraph.component';
import { UnescapePipe } from './utilities/unescape/unescape.pipe';
import { AreasViewComponent } from './views/areas/areas/areas-view/areas-view.component';
import { AreaOptionsComponent } from './resources/area/area-options/area-options.component';
import { ActivePipe } from './utilities/active/active.pipe';
import { ClusterOptionsComponent } from './resources/cluster/cluster-options/cluster-options.component';
import { SumPipe } from './utilities/sum/sum.pipe';
import { AreaAddComponent } from './resources/area/area-add/area-add.component';
import { ClusterAddComponent } from './resources/cluster/cluster-add/cluster-add.component';
import { ClusterEditComponent } from './resources/cluster/cluster-edit/cluster-edit.component';
import { AreaService } from './resources/area/area.service';
import { BasicAreaService } from './resources/basic-area/basic-area.service';
import { BuildingService } from './resources/building/building.service';
import { UnauthorizedInterceptorService } from './api/interceptors/unauthorized-interceptor.service';
import { LoaderInterceptorService } from './api/interceptors/loader-interceptor.service';
import { ClusterTotalsComponent } from './views/areas/areas/cluster-totals/cluster-totals.component';
import { QualityLevelPipe } from './utilities/quality-level/quality-level.pipe';
import { RouterService } from './utilities/router/router.service';
import { ErrorInterceptorService } from './api/interceptors/error-interceptor.service';


@NgModule({
  declarations: [
    TreeviewComponent,
    HighlightPipe,
    TranslatePipe,
    ModalComponent,
    ElementOptionsComponent,
    UserIconComponent,
    ConvertResourceToJsonPipe,
    ModalPromptComponent,
    ModalTinyMCEComponent,
    ElementLogsItemComponent,
    ElementLogsCommentBoxComponent,
    DateAgoPipe,
    BuildingInfoRatioComponent,
    InlineEditAreaFunctionalityComponent,
    ClusterInfoRatioComponent,
    BuildingOptionsComponent,
    ProjectInfoViewComponent,
    ProjectInfoElementComponent,
    PveFilterPipe,
    ProjectInfoToolbarComponent,
    SafeHtmlPipe,
    SubmoduleOptionsComponent,
    ProjectInfoIndexComponent,
    ModuleOptionsComponent,
    ProjectInfoButtonAddComponent,
    ModalAssignToComponent,
    ElementViewComponent,
    ElementFormComponent,
    ElementStatusComponent,
    ElementAssignToComponent,
    ElementSidebarComponent,
    ElementFormControlsComponent,
    ElementValueComponent,
    StripHtmlPipe,
    AdminToolsViewComponent,
    AdminToolsFindCircularComponent,
    AreaDetailsViewComponent,
    UnitPipe,
    StatusPipe,
    ElementFormBreadcrumbsComponent,
    AreaDetailsPropertiesComponent,
    BasicAreaDetailsPropertiesComponent,
    ElementsViewComponent,
    ElementsTableComponent,
    ModalFiltersComponent,
    ModalParagraphAddComponent,
    ModalRestoreParagraphComponent,
    UnescapePipe,
    AreasViewComponent,
    AreaOptionsComponent,
    ActivePipe,
    ClusterOptionsComponent,
    SumPipe,
    AreaAddComponent,
    ClusterAddComponent,
    ClusterEditComponent,
    ClusterTotalsComponent,
    QualityLevelPipe,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    UpgradeModule,
    AppMaterial,
    BrowserAnimationsModule,
    // NoopAnimationsModule,
    FormsModule,
    EditorModule,
    ReactiveFormsModule,
    HttpClientModule,
    // DeviceDetectorModule.forRoot()
    // CKEditorModule
  ],
  providers: [
    TranslatePipe,
    TranslateService,
    ConvertResourceToJsonPipe,
    DecimalPipe,
    DatePipe,
    PveFilterPipe,
    StripHtmlPipe,
    UnescapePipe,

    // Interceptors
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: UnauthorizedInterceptorService,
    //   multi: true
    // },

    // Stores
    // For use with Injector.get().
    // Use when a circular dependency prevents otherwise.
    AreaService, {
      provide: 'AreaService',
      useClass: AreaService
    },
    BasicAreaService, {
      provide: 'BasicAreaService',
      useClass: BasicAreaService
    },
    BuildingService, {
      provide: 'BuildingService',
      useClass: BuildingService
    },

    // Legacy
    {
      provide: '$mdDialog',
      useFactory: ($injector: any) => $injector.get('$mdDialog'),
      deps: ['$injector']
    },
    {
      provide: 'sgAuth',
      useFactory: ($injector: any) => $injector.get('Auth'),
      deps: ['$injector']
    },
    {
      provide: 'sgConstants',
      useFactory: ($injector: any) => $injector.get('Constants'),
      deps: ['$injector']
    },
    {
      provide: 'sgDateAgo',
      useFactory: ($injector: any) => $injector.get('sgDateAgo'),
      deps: ['$injector']
    },
    {
      provide: 'sgLabels',
      useFactory: ($injector: any) => $injector.get('Labels'),
      deps: ['$injector']
    },
    {
      provide: '$sgLocation',
      useFactory: ($injector: any) => $injector.get('$location'),
      deps: ['$injector']
    },
    {
      provide: 'sgLABELS_CONSTANT',
      useFactory: ($injector: any) => $injector.get('LABELS_CONSTANT'),
      deps: ['$injector']
    },
    {
      provide: 'sgProject',
      useFactory: ($injector: any) => $injector.get('Project'),
      deps: ['$injector']
    },
    {
      provide: 'sgProjectDataService',
      useFactory: ($injector: any) => $injector.get('ProjectDataservice'),
      deps: ['$injector']
    },
    {
      provide: '$sgRootScope',
      useFactory: ($injector: any) => $injector.get('$rootScope'),
      deps: ['$injector']
    },
    {
      provide: '$sgScope',
      useFactory: ($injector: any) => $injector.get('$scope'),
      deps: ['$injector']
    },
    {
      provide: '$sgState',
      useFactory: ($injector: any) => $injector.get('$state'),
      deps: ['$injector']
    },
    {
      provide: '$sgStateParams',
      useFactory: ($injector: any) => $injector.get('$stateParams'),
      deps: ['$injector']
    },
    {
      provide: '$sgTransitions',
      useFactory: ($injector: any) => $injector.get('$transitions'),
      deps: ['$injector']
    },
    {
      provide: 'sgTranslateHelpers',
      useFactory: ($injector: any) => $injector.get('sgTranslateHelpers'),
      deps: ['$injector']
    },
    {
      provide: 'sgUser',
      useFactory: ($injector: any) => $injector.get('User'),
      deps: ['$injector']
    },
  ]
})

export class AppModule {
  constructor(private upgrade: UpgradeModule) { }

  ngDoBootstrap() {
    document.addEventListener('specsguardready', () => {
      this.upgrade.bootstrap(document.body, ['specsguardApp'], { strictDi: false });
    });
  }
}
